var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#243665"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1772_1355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2154 7.82029L17.1798 6.78457C16.7066 6.31138 15.9367 6.3114 15.4635 6.78457L15.0582 7.18995L17.81 9.94205L18.2154 9.53667C18.6897 9.06236 18.6897 8.29464 18.2154 7.82029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63391 14.8398L7.14818 17.4631C7.12811 17.5715 7.16267 17.6829 7.24063 17.7608C7.31869 17.8389 7.43008 17.8734 7.53836 17.8533L10.1614 17.3675L7.63391 14.8398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5847 7.66406L7.99521 14.2541L10.7471 17.0061L17.3366 10.4162L14.5847 7.66406Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1772_1355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(7.14258 6.42969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.e7f7abc7a423a6d47ed687628efdfe33.svg";
export { ForwardRef as ReactComponent };